import Marquee from "react-fast-marquee";
import { useLanguage } from "../i18n/LanguageContext";

const EditorialMarquee = () => {
  const { t, lang } = useLanguage();
  return (
    <div data-testid="editorial-marquee" className="marquee-mask border-y border-white/5 bg-surface/50 py-6" dir={lang === "ar" ? "rtl" : "ltr"}>
      <Marquee speed={28} gradient={false} pauseOnHover>
        {t.marquee.map((item, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="font-display text-xl font-light text-zinc-600">{item}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-gold/40" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default EditorialMarquee;
